module.exports = "https://static.im-cdn.com/mjc/storefront/Bright/static/media/left.deab2878.svg";